module.exports = __webpack_public_path__ + "components/discount-pages/db-journey/static/jordy-1600-48c5aa8548226ad42f2c5c57e1edd642.jpg";